
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"25","height":"26","viewBox":"0 0 25 26","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.39 25.18a12.565 12.565 0 007.781-5.518c.212-.334-.162-.735-.512-.547-1.335.713-2.92 1.127-4.62 1.127-4.714 0-8.543-3.175-8.622-7.117a3.198 3.198 0 011.93-3.002h-.002c-.684.238-1.454.337-2.05.748-2.258 1.559-3.63 4.444-3.41 7.038.211 2.517 1.756 5.467 4.43 6.785 1.398.689 3.2.577 5.075.485z","fill":"#F8FAFC"}}),_c('path',{attrs:{"d":"M15.275 16.78c.847.308 1.78.478 2.762.478 3.845 0 6.962-2.617 6.963-5.847C25 5.01 19.005.558 12.666.501 5.756.438.063 6 0 12.884c0 0 1.729-5.319 7.905-5.319 4.18 0 7.101 2.47 7.581 4.339a3.105 3.105 0 01-.617 3.197 1.035 1.035 0 00.406 1.68z","fill":"#CBD5E1"}}),_c('path',{attrs:{"d":"M15.487 11.903c-.48-1.867-2.079-5.466-7.27-5.466C.234 6.437 0 12.883 0 12.883-.063 19.84 5.58 25.5 12.55 25.5c.976 0 1.926-.111 2.838-.321-10.124.495-11.164-12.575-4.044-15.057.36-.153.755-.24 1.171-.245a3.136 3.136 0 012.97 2.026z","fill":"#E2E8F0"}})])
          )
        }
      }
    